import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getApiLanguage } from "src/services/commonLanguageHeader";
import {
  getRawDataDeviceLookup,
  getRawDataLogs,
  type RawDataDeviceLookupParams,
  type RawDataLogParams,
} from "src/services/rawDataLogService";
import { useGeneralRefetchOverride } from "./general.queries";
import { QueryNames } from "./queries.constant";

type QueryOptions = { enabled?: boolean };

export const useQueryRawDataLogs = (
  params?: RawDataLogParams,
  options: QueryOptions = {},
) => {
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);
  const enabled = !!params?.imei && !!params.date && options.enabled !== false;

  return useGeneralRefetchOverride(
    useQuery({
      queryKey: [...QueryNames.rawDataLog, params, language],
      queryFn: () => getRawDataLogs(params as RawDataLogParams, language),
      enabled,
      retry: false,
      placeholderData: (previousData) => previousData,
    }),
    enabled,
  );
};

export const useQueryRawDataDeviceLookup = (
  params?: RawDataDeviceLookupParams,
  options: QueryOptions = {},
) => {
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);
  const enabled =
    !!params?.query &&
    params.query.trim().length >= 3 &&
    options.enabled !== false;

  return useGeneralRefetchOverride(
    useQuery({
      queryKey: [...QueryNames.rawDataDeviceLookup, params, language],
      queryFn: () =>
        getRawDataDeviceLookup(params as RawDataDeviceLookupParams, language),
      enabled,
      retry: false,
      staleTime: 30_000,
    }),
    enabled,
  );
};
